import { IReportItem } from "./reports-Item.model";

export class IReportBase {
    
    reportId: string;
    projectId: string;
    sortedBy: string;
    sortDirection: string;
    status: string;
    searchBy: string;
    searchByValue: string;
    restrictionType: string;
    reportName: string;
    excludeTheseTags: string[];
    includeTheseTags: string[];
    isCustomHeaderSelected:boolean=false;
    customHeader:string;
    asOfDate:string;
    selectedIDs:string;
    fromAdvancedSearch: boolean = false;
    constructor(){
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/reports/reports-base.model.ts